import { Box, MenuItem, Stack } from '@mui/material';
import { common } from '@mui/material/colors';
// import BaseNumberField from 'common/components/base-number-field';
import { BaseSelectField } from 'common/components/base-select-field';
// import BaseTextField from 'common/components/base-text-field';
import RequiredLabel from 'common/components/required-label';
import {
    colors,
    // styleInputNumber
} from 'common/constants';
import { generateScaleMenuItems } from 'pages/admin/campaign-overview/constants';
import React from 'react';
import {
    FieldErrors,
    // useFieldArray,
    useFormContext,
} from 'react-hook-form';
// import { createStyleSheet } from 'utils/helpers';
import { IQuestionAnswer, IQuestionBaseProps } from 'types/campaign-design';
import QuestionDnD from './question-dnd';

const QuestionScore: React.FC<IQuestionBaseProps> = ({
    question,
    ...props
}) => {
    const {
        watch,
        // control,
        formState,
        setValue,
    } = useFormContext();
    // const { append, remove } = useFieldArray({
    //     control,
    //     name: `data.answers`,
    // });
    const [options, setOptions] = React.useState<
        {
            label: string;
            value: number;
        }[]
    >([]);
    const scale = watch('data.scale');
    // const numberOfRows = watch(`data.numberOfRows`);
    const answers = watch('data.answers');
    const gap = watch('data.gap') || 10;

    React.useEffect(() => {
        const errors = formState?.errors?.data as FieldErrors<{
            scale: number;
        }>;

        let effectiveScale = scale;
        if (errors?.scale) {
            effectiveScale = 100;
            setValue('scale', 100);
        }

        if (effectiveScale) {
            const newOptions = generateOptions(0, effectiveScale, gap);
            setOptions(newOptions);
        }
    }, [scale, formState, setValue, gap]);

    // Tuỳ chọn số hàng
    // React.useEffect(() => {
    //     const currentLength = answers?.length;
    //     if (!numberOfRows) {
    //         return;
    //     }
    //     if (currentLength < numberOfRows) {
    //         for (let i = currentLength; i < numberOfRows; i++) {
    //             append({ answer: `Tuỳ chọn ${i + 1}` });
    //         }
    //     } else if (currentLength > numberOfRows) {
    //         for (let i = currentLength; i > numberOfRows; i--) {
    //             remove(i - 1);
    //         }
    //     }
    // }, [numberOfRows, answers, append, remove]);

    const generateOptions = (start: number, end: number, step: number) => {
        return Array.from({ length: (end - start) / step + 1 }, (_, index) => {
            const value = start + index * step;
            return { label: value.toString(), value };
        });
    };

    return (
        <Box>
            <Stack p={'0px 35px 35px 35px'} gap={1}>
                <Box sx={{ display: 'flex', alignItems: 'start', gap: 8 }}>
                    <QuestionDnD {...props} question={question} />
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 1,
                            width: '100%',
                        }}
                    >
                        {answers?.map(
                            (item: IQuestionAnswer, fieldIndex: number) => {
                                return (
                                    <Box
                                        key={`${item.id}_${fieldIndex}`}
                                        sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'flex-start',
                                            gap: 1,
                                        }}
                                    >
                                        {/* <BaseTextField
                                            autoComplete="off"
                                            fullWidth={false}
                                            name={`data.answers.${fieldIndex}.answer`}
                                            size="small"
                                            placeholder="Nhập tùy chọn câu trả lời"
                                            sx={styles.answer}
                                            InputProps={{
                                                inputProps: {
                                                    maxLength: 255,
                                                },
                                            }}
                                        />
                                        <Box
                                            sx={{
                                                borderRight: `2px solid ${colors.main}`,
                                                height: '44px',
                                            }}
                                        ></Box> */}
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                gap: 1,
                                                flexWrap: 'wrap',
                                            }}
                                        >
                                            {options.map((option, index) => {
                                                return (
                                                    <Box
                                                        key={index}
                                                        sx={{
                                                            width: '44px',
                                                            height: '44px',
                                                            backgroundColor:
                                                                common.white,
                                                            display: 'flex',
                                                            alignItems:
                                                                'center',
                                                            justifyContent:
                                                                'center',
                                                            color: colors.main,
                                                            border: `1px solid ${colors.main}`,
                                                            fontWeight: '500',
                                                        }}
                                                    >
                                                        {option.label}
                                                    </Box>
                                                );
                                            })}
                                        </Box>
                                    </Box>
                                );
                            }
                        )}
                    </Box>
                </Box>
            </Stack>
            <Stack
                flexDirection={'row'}
                flexWrap={'wrap'}
                gap={4}
                p={'35px'}
                sx={{
                    borderTop: `2px dashed var(--color-primary)`,
                }}
            >
                {/* <Stack flexDirection={'column'} gap={'20px'}>
                    <RequiredLabel
                        label="Số hàng"
                        required={false}
                        sx={{ fontSize: '16px', fontWeight: '500' }}
                    />
                    <BaseNumberField
                        sx={styleInputNumber}
                        size="small"
                        name={`data.numberOfRows`}
                        min={1}
                        max={20}
                        InputProps={{
                            readOnly: true,
                        }}
                        forceDisableMinus={
                            !!question.answerFromOtherQuestionLogic?.id
                        }
                        forceDisablePlus={
                            !!question.answerFromOtherQuestionLogic?.id
                        }
                        disabled={!!question.answerFromOtherQuestionLogic?.id}
                    />
                </Stack> */}
                <Stack flexDirection={'column'} gap={'20px'}>
                    <RequiredLabel
                        label="Thang điểm"
                        required={false}
                        sx={{ fontSize: '16px', fontWeight: '500' }}
                    />
                    <BaseSelectField
                        name={`data.scale`}
                        size="small"
                        sx={{
                            '& .MuiInputBase-root': {
                                height: '24px',
                                backgroundColor: common.white,
                            },
                        }}
                        defaultValue={100}
                    >
                        {generateScaleMenuItems(10, 100, 10).map(
                            (item, index) => (
                                <MenuItem key={index} value={item}>
                                    {item}
                                </MenuItem>
                            )
                        )}
                    </BaseSelectField>
                </Stack>
                <Stack flexDirection={'column'} gap={'20px'}>
                    <RequiredLabel
                        label="Khoảng cách"
                        required={false}
                        sx={{ fontSize: '16px', fontWeight: '500' }}
                    />
                    <BaseSelectField
                        name={`data.gap`}
                        size="small"
                        sx={{
                            '& .MuiInputBase-root': {
                                height: '24px',
                                backgroundColor: common.white,
                            },
                        }}
                        defaultValue={10}
                    >
                        <MenuItem value={1}>1</MenuItem>
                        <MenuItem value={5}>5</MenuItem>
                        <MenuItem value={10}>10</MenuItem>
                    </BaseSelectField>
                </Stack>
            </Stack>
        </Box>
    );
};

// const styles = createStyleSheet({
//     answer: {
//         '& .MuiInputBase-root': {
//             height: '44px',
//             borderRadius: '50px',
//             background: common.white,
//         },
//     },
// });
export default QuestionScore;
